import { useState } from 'react'
import { HiMiniPlus } from 'react-icons/hi2'

import { Tooltip } from './Tooltip'
import { Indicator } from './Indicator'

import { salary } from '../../i18n/translatedMessages'

export function Suggestions({ algorithm, employee, level, onClick }) {
	const [mydna, setMydna] = useState(true)

	const color = {
		employee: { primary: 'tw-bg-[#0D554A] tw-text-white', secondary: 'tw-bg-[#00A28B] tw-text-white', lightColor: 'tw-bg-[#C7FFF1] tw-text-[#00A28B]' },
		algorithm: { primary: 'tw-bg-[#084E72] tw-text-white', secondary: 'tw-bg-[#008ACD] tw-text-white', lightColor: 'tw-bg-[#DFF3FE] tw-text-[#008ACD]' },
	}

	return (
		<div className='tw-relative tw-w-full border tw-rounded-md tw-bg-[#F9FAFC] tw-p-2 tw-h-full tw-flex tw-flex-col tw-justify-between'>
			<div>
				<div className='tw-p-2 tw-bg-[#F1F4F9] tw-flex tw-w-full tw-rounded-md'>
					<button onClick={() => setMydna(true)} className={`tw-w-full tw-rounded-md border-0 tw-p-2 ${mydna ? 'tw-bg-white tw-shadow-sm border' : 'tw-bg-transparent'}`}>
						{salary.suggestionsBtnAlgorithm}
					</button>
					<button onClick={() => setMydna(false)} className={`tw-w-full tw-rounded-md border-0 tw-p-2 ${!mydna ? 'tw-bg-white tw-shadow-sm border' : 'tw-bg-transparent'}`}>
						{salary.suggestionsBtnEmployee}
					</button>
				</div>
				<div className='tw-p-2 tw-mt-2 tw-space-y-2 tw-h-[200px] tw-overflow-auto'>
					{mydna &&
						algorithm.map((item, index) => (
							<div key={index} className='tw-flex tw-items-center tw-justify-between'>
								<div className='tw-flex tw-items-center tw-gap-1'>
									<Indicator up={item.level.id > level} className={color.algorithm.lightColor} />
									<span>{item.level.value}</span>
									<span className='tw-text-gray-500'>{item.area.value}</span>
								</div>
								<Tooltip text={salary.suggestionsTooltip}>
									<button
										onClick={() => onClick(item)}
										className={`tw-flex tw-items-center tw-justify-center tw-w-[30px] tw-h-[30px] tw-rounded-full tw-bg-purple-100 hover:tw-bg-purple-200 active:tw-bg-purple-300 tw-text-[#6C4FDB] border-0`}
									>
										<HiMiniPlus />
									</button>
								</Tooltip>
							</div>
						))}
					{!mydna &&
						employee.map((item, index) => (
							<div key={index} className='tw-flex tw-items-center tw-justify-between'>
								<div className='tw-flex tw-items-center tw-gap-1'>
									<Indicator up={item.level.id > level} className={color.employee.lightColor} />
									<span>{item.level.value}</span>
									<span className='tw-text-gray-500'>{item.subarea.value}</span>
								</div>
								<Tooltip text={salary.suggestionsTooltip}>
									<button
										onClick={() => onClick(item)}
										className={`tw-flex tw-items-center tw-justify-center tw-w-[30px] tw-h-[30px] tw-rounded-full tw-bg-purple-100 hover:tw-bg-purple-200 active:tw-bg-purple-300 tw-text-[#6C4FDB] border-0`}
									>
										<HiMiniPlus />
									</button>
								</Tooltip>
							</div>
						))}
				</div>
			</div>
			<div className='tw-font-bold tw-text-gray-500 tw-text-sm tw-mt-2'>Mostrando {mydna ? algorithm.length : employee.length} resultados</div>
		</div>
	)
}
